import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a21ca2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12 flex justify-content-center mt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "col-12 flex justify-content-center mt-6"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Internal error")
const _hoisted_4 = {
  key: 2,
  class: "col-12 p-0 flex flex-column justify-content-center border-top-1 border-200"
}
const _hoisted_5 = {
  key: 0,
  id: "username2-help",
  class: "p-error mb-1"
}
const _hoisted_6 = { class: "w-full flex flex-row-reverse" }

import { useSubscription, useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { reactive, toRefs } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { required, maxLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { Comment } from '@/models/comment';
import CommentList from "./CommentList.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    postId: null
  },
  setup(__props: any) {

const props = __props as {
  postId: string,
}

const { isAuthenticated } = useAuth0();



const { postId } = toRefs(props);

const comment = reactive({
  text: "",
});

const rules = {
  text: { required, maxLength: maxLength(400) },
};

const v$ = useVuelidate(rules, comment);

const { loading, result, error, onResult } = useSubscription(
  gql`
    subscription MySubscription($post_uuid: uuid!) {
      comment(where: { post_uuid: { _eq: $post_uuid } }) {
        uuid
        content
        user {
          username
          id
        }
      }
    }
  `,
  {
    post_uuid: postId?.value,
  }
);

onResult(({ data: { comment } }) => {
  comment.forEach((comment: Comment) => {
    comment.content = processComment(comment.content);
  });
});

const mutation = gql`
  mutation insertCommentOne(
    $content: String!
    $post_uuid: uuid!
  ) {
    insert_comment_one(
      object: { content: $content, post_uuid: $post_uuid }
    ) {
      uuid
    }
  }
`;

const { loading: mutationLoading, mutate, onDone } = useMutation(mutation);

onDone(() => {
  comment.text = "";
  v$.value.$reset();
});

const postComment = () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    mutate({
      content: comment.text,
      post_uuid: postId?.value,
    });
  }
};

const processComment = (content: string) => {
  content = content.replace(/</g, "&lt;").replace(/>/g, "&gt;"); // PREVENT HTML INJECTION
  content = content.replace(
    /(https?:\/\/)([^ ]+)/g,
    '<a target="_blank" href="$&">$2</a>'
  ); // INSERT ANCHOR TAGS AROUND LINKS
  return content;
};

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!

  return (_unref(loading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ProgressSpinner)
      ]))
    : (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Message, { severity: "error" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : (_unref(result))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_TextArea, {
              class: _normalizeClass(["w-full mt-1 mb-1", { 'p-invalid': _unref(v$).text.$error }]),
              modelValue: _unref(comment).text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(comment).text) = $event)),
              placeholder: "Write a comment...",
              autoResize: true
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).text.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_unref(v$).text.$errors[0].$message), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_unref(isAuthenticated))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: postComment,
                    label: "Comment",
                    loading: _unref(mutationLoading),
                    class: "p-button-sm"
                  }, null, 8, ["loading"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Comment",
                    disabled: "",
                    title: "Log in to post comments",
                    class: "p-button-sm"
                  }))
            ]),
            _createVNode(CommentList, {
              comments: _unref(result).comment
            }, null, 8, ["comments"])
          ]))
        : _createCommentVNode("", true)
}
}

})